module.exports = __webpack_public_path__ + "static/media/tyggje.0537d897.m4a";